module.exports = __webpack_public_path__ + "img/53ne.60b594ad.svg";